import { initFinder } from 'uhs-finder.dom';

function boot(scope) {
  const root = scope.querySelector('[data-uhs-finder]');
  if (!root) return;

  try {
    initFinder(root);
  } catch (err) {
    console.error('UHS finder init failed:', err);
  }
}

// ES modules are deferred, so the DOM is already parsed.
boot(document);

// The theme editor swaps in fresh section markup without re-running this module
// (its URL is already in the browser's module map), leaving the new button with
// no listener. Scoping the query to the reloaded element keeps an unrelated
// section's reload from double-wiring the finder.
document.addEventListener('shopify:section:load', event => {
  if (event.target && typeof event.target.querySelector === 'function') boot(event.target);
});
